module.exports = __webpack_public_path__ + "static/img/C4D0037.e18dd9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intru/C4D0037.jpg
// module id = FWMc
// module chunks = 0